import React, { createContext, useContext, useState, useCallback } from 'react';

interface MobileAIChatContextType {
  isOpen: boolean;
  openAIChat: () => void;
  closeAIChat: () => void;
  toggleAIChat: () => void;
  pendingMessage: string | null;
  setPendingMessage: (msg: string | null) => void;
}

const MobileAIChatContext = createContext<MobileAIChatContextType | undefined>(undefined);

export const MobileAIChatProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [pendingMessage, setPendingMessage] = useState<string | null>(null);

  const openAIChat = useCallback(() => setIsOpen(true), []);
  const closeAIChat = useCallback(() => {
    setIsOpen(false);
    setPendingMessage(null);
  }, []);
  const toggleAIChat = useCallback(() => setIsOpen(prev => !prev), []);

  return (
    <MobileAIChatContext.Provider value={{ isOpen, openAIChat, closeAIChat, toggleAIChat, pendingMessage, setPendingMessage }}>
      {children}
    </MobileAIChatContext.Provider>
  );
};

export const useMobileAIChat = (): MobileAIChatContextType => {
  const context = useContext(MobileAIChatContext);
  if (!context) {
    throw new Error('useMobileAIChat must be used within a MobileAIChatProvider');
  }
  return context;
};
